// Cookie consent manager — gates non-essential tags (PostHog analytics/session
// recording today; Meta Pixel / Google Analytics when added) until explicit, revocable opt-in.
const KEY = "acx_cookie_consent";
export const OPEN_EVENT = "acx:open-cookie-settings";
export const UPDATED_EVENT = "acx:consent-updated";

export function getConsent() {
  try {
    return JSON.parse(localStorage.getItem(KEY));
  } catch (e) {
    console.warn("Consent: failed to parse stored consent", e);
    return null;
  }
}

export function applyConsent(c) {
  if (typeof window === "undefined") return;
  const ph = window.posthog;
  if (ph && typeof ph.opt_in_capturing === "function") {
    if (c.analytics) {
      ph.opt_in_capturing();
      if (typeof ph.startSessionRecording === "function") {
        try { ph.startSessionRecording(); } catch (e) { console.debug("Consent: startSessionRecording skipped", e); }
      }
    } else if (typeof ph.opt_out_capturing === "function") {
      ph.opt_out_capturing();
      if (typeof ph.stopSessionRecording === "function") {
        try { ph.stopSessionRecording(); } catch (e) { console.debug("Consent: stopSessionRecording skipped", e); }
      }
    }
  }
  // Marketing tags (Meta Pixel / Google Ads) would be (de)activated here once added,
  // strictly conditioned on c.marketing.
  window.dispatchEvent(new CustomEvent(UPDATED_EVENT, { detail: c }));
}

export function saveConsent(partial) {
  const data = {
    essential: true,
    analytics: !!partial.analytics,
    marketing: !!partial.marketing,
    ts: Date.now(),
  };
  try { localStorage.setItem(KEY, JSON.stringify(data)); }
  catch (e) { console.warn("Consent: failed to persist consent to localStorage", e); }
  applyConsent(data);
  return data;
}

// Re-apply a previously stored choice on app load (keeps opt-in persistent across visits).
export function initConsent() {
  const stored = getConsent();
  if (stored) applyConsent(stored);
  return stored;
}

export function openCookieSettings() {
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(OPEN_EVENT));
}
